import React, { useState } from "react";
import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { USER_API, DevMode, RESOURCES_API } from "../../functions";
// import ESCAlert from "./EscapeHandler";
import { Transition } from '@headlessui/react'
import { Fragment, useRef } from 'react'
import { Dialog } from '@headlessui/react'
import { FcQuestions } from 'react-icons/fc'
import Cookies from "js-cookie";
import ToolTipQuestions from "./ToolTipQuestions";
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import { GiHamburgerMenu, GiCancel } from 'react-icons/gi';
import "./Test.css";
import Swal from "sweetalert2";




const Test = () => {
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [ORIGINALTEST, setORIGINALTEST] = useState([]);
  const [testTitle, setTestTitle] = useState("");
  const [timeLimit, setTimeLimit] = useState(60);
  const [totalQ, setTotalQ] = useState(0);
  const [Questions, setQuestions] = useState([{}]);
  const [ESCController, setESCController] = useState(false);
  const [ifESC, setIfESC] = useState(false);

  const [contentLoaded, setContentLoaded] = useState(false);

  const [responses, setResponses] = useState([]);

  useEffect(() => {
    window.addEventListener("visibilitychange", visibilityChangeHandler);
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener("visibilitychange", visibilityChangeHandler);
    }
  }, []);

  const visibilityChangeHandler = () => {
    if (!DevMode) {
      if (document.hidden) {
        setIfESC(true);
      } else {
        Swal.fire({
          title: 'Warning !!',
          text: 'You are not allowed to switch tabs. If you do so, your test will be submitted.',
          icon: 'warning',
          timer: 1000,
        })
      }
    }
  }


  const handleFullScreen = () => {
    const element = document.documentElement;

    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
    setIfESC(false);
  }

  const TestLoader = async () => {

    let OriginalTest, TestTitle, duration;
    OriginalTest = localStorage.getItem("test");
    OriginalTest = JSON.parse(OriginalTest);


    let testId = OriginalTest.TestInfo.TestId;
    TestTitle = OriginalTest.TestInfo.TestName;
    duration = OriginalTest.TestInfo.TestDuration;

    let timeOut = Date.now() + duration * 60 * 1000;

    if (localStorage.getItem("timeOut")) {
      let timeOut1 = localStorage.getItem("timeOut");
      timeOut = JSON.parse(timeOut1);
      setTimeLimit((timeOut - Date.now()) / 1000);

    } else {
      localStorage.setItem("timeOut", timeOut);
      setTimeLimit((timeOut - Date.now()) / 1000);
    }


    duration = OriginalTest.TestDuration;
    setTestTitle(TestTitle);
    setORIGINALTEST(OriginalTest);
    let totalQues = OriginalTest.QuestionSet.length;
    setTotalQ(parseInt(totalQues));
    setQuestions(OriginalTest.QuestionSet);


    let emptyResponses = [];
    for (let i = 0; i < totalQues; i++) {
      emptyResponses.push({
        QuestionID: OriginalTest.QuestionSet[i].QuestionId,
        Response: {
          Options: [],
          IntegerAnswer: null,
          status: 0,
        },
      });
    }
    // console.log(emptyResponses);
    setResponses(emptyResponses);

    setContentLoaded(true);
  }
  const checkuser = async () => {
    const user = Cookies.get("user");
    if (user === undefined) {
      navigate("/login");
    }
    else {
      TestLoader();
    }
  }



  useEffect(() => {
    checkuser();
  }, [])

  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = "Sure?";
    Swal.fire({
      title: 'Warning !!',
      text: 'Test going to be submitted.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#3085d6',
    }).then((result) => {
      if (result.isConfirmed) {
        handleSubmit();
      }
    })
  };



  const navigate = useNavigate();



  const handleNext = () => {
    if (currentQuestion < totalQ) {
      setCurrentQuestion((prevCurrentQuestion) => prevCurrentQuestion + 1);
    }
  };

  const handlePrevious = () => {
    if (currentQuestion > 1) {
      setCurrentQuestion((prevCurrentQuestion) => prevCurrentQuestion - 1);
    }

  };

  const handleOptionSelect = (question, option) => {
    setSelectedOptions((prevSelectedOptions) => ({
      ...prevSelectedOptions,
      [question]: option,
    }));
  };

  const handleNormalScreen = () => {
    // if already full screen; exit
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    ) {
      document.exitFullscreen();
      navigate('/', { replace: true });
    }
    else {
      navigate('/', { replace: true });
    }
  }

  const handleSubmit = () => {
    POSTAPI();
  };

  const POSTAPI = async () => {
    let userID = localStorage.getItem('user') || localStorage.getItem('userID');
    userID = JSON.parse(userID);

    let res = await axios.patch(`${USER_API}/submitTest/${userID}`, {
      test: localStorage.getItem("testId"),
      date: new Date().toLocaleDateString(),
      responses: responses,
    });

    if (res.status === 201) {
      localStorage.removeItem("timeOut");
      localStorage.removeItem("test");
      handleNormalScreen();
    }
    else {
      alert("Something went wrong");
    }

  }

  const handleContextMenu = (event) => {
    if (!DevMode) {
      event.preventDefault();
    }
  };

  const [isOpen, setIsOpen] = useState(false);

  const modalRef = useRef();
  // if clicked outside modal, close modal
  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  return (
    <div className="bg-gray-100 h-full fullscreen" onContextMenu={handleContextMenu}>
      <div className="bg-white py-3 px-3 flex justify-between items-center">
        <h1 className="text-xl font-medium">{testTitle}</h1>
        <div className="flex items-center">
          <Timer
            timeLimit={timeLimit}
            setTimeLimit={setTimeLimit}
            handleSubmit={handleSubmit}
          />
        </div>
      </div>
      <div className="sm:hidden fixed z-10 right-0" ref={modalRef}>
        <button className="mr-4 text-black scale-150 rounded-md bg-white p-1"
          onClick={(e) => {
            e.preventDefault();
            setIsOpen(!isOpen);
          }}>
          {isOpen ? (
            <GiCancel />
          ) : (
            <GiHamburgerMenu />
          )}
        </button>
        <Transition
          show={isOpen}
          enter="transition-opacity duration-75"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="bg-white rounded-md fixed w-3/4 right-0 p-2 h-max px-4 border-2 border-gray-400">
            <ToolTipQuestions />
            <p className="text-center lg:text-lg font-medium mb-2">Questions</p>
            <div className="grid gap-2 grid-cols-3 max-h-[50vh] overflow-auto">
              {Array.from({ length: totalQ }).map((_, index) => {

                const questionNumber = index + 1;
                let bgColor = "bg-gray-500 text-black";
                if (responses[index].Response.status === 0) {
                  bgColor = "bg-gray-300 text-black rounded";
                }
                else if (responses[index].Response.status === 1) {
                  bgColor = "bg-green-300 text-white rounded";
                }
                else if (responses[index].Response.status === 2) {
                  bgColor = "bg-yellow-500 text-black rounded";
                }
                else if (responses[index].Response.status === 3) {
                  bgColor = "bg-orange-500 rounded text-white";
                }

                // make the current question number bold and make it's border blue
                if (questionNumber === currentQuestion) {
                  bgColor = bgColor.concat("rounded border-2 border-blue-800");
                }
                return (
                  <div
                    key={index}
                    className={`text-center py-2 px-3 cursor-pointer ${bgColor}`}
                    onClick={() => setCurrentQuestion(questionNumber)}
                  >
                    {questionNumber}
                  </div>
                );
              })}
            </div>
            <div className="flex justify-center align-middle m-2">
              <button className="bg-blue-500 min-w-min max-w-max text-white p-[min(2vw,15px)] m-[min(2vw,15px)] rounded-md" onClick={() => {
                Swal.fire({
                  title: 'Warning !!',
                  text: 'Test going to be submitted.',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Submit',
                  cancelButtonText: 'Cancel',
                  confirmButtonColor: '#3085d6',
                }).then((result) => {
                  if (result.isConfirmed) {
                    handleSubmit();
                  }
                })
              }
              }>
                Submit
              </button>
            </div>
          </div>
        </Transition>
      </div>
      {ifESC ? <ESCAlert handleSubmit={handleSubmit} handleFullScreen={handleFullScreen} setESCController={setESCController} /> : null}
      <div className="container py-8 flex">
        <div className="w-3/4 m-1">
          {contentLoaded ?
            (
              <QuestionCard
                Question={Questions}
                currentQuestion={currentQuestion}
                setSelectedOption={handleOptionSelect}
                responses={responses}
                setResponses={setResponses}
              />
            ) :
            (
              <div>
                loading
              </div>
            )
          }

          <button
            className="bg-blue-500 p-[min(3vw,18px)] rounded-md fixed bottom-10 left-10 text-white cursor-pointer "
            onClick={handlePrevious}
            disabled={currentQuestion === 1}
          >
            Previous
          </button>
          <button
            className="bg-blue-500 p-[min(3vw,18px)] rounded-md text-white fixed bottom-10 cursor-pointer right-10 "
            onClick={handleNext}
            disabled={currentQuestion === totalQ}
          >
            Next
          </button>

        </div>
        <div className="w-1/4 hidden sm:inline-block">
          <div className="bg-white p-4 rounded-md h-[33vh] ">
            <ToolTipQuestions />
            <p className="text-center lg:text-lg font-medium mb-2">Questions</p>
            <div className="flex flex-wrap gap-2 sm:grid sm:grid-cols-[auto] lg:grid-cols-4 h-3/4 overflow-auto">
              {Array.from({ length: totalQ }).map((_, index) => {

                const questionNumber = index + 1;
                let bgColor = "bg-gray-500 text-black";
                if (responses[index].Response.status === 0) {
                  bgColor = "bg-gray-300 text-black rounded";
                }
                else if (responses[index].Response.status === 1) {
                  bgColor = "bg-green-300 text-white rounded";
                }
                else if (responses[index].Response.status === 2) {
                  bgColor = "bg-yellow-500 text-black rounded";
                }
                else if (responses[index].Response.status === 3) {
                  bgColor = "bg-orange-500 rounded text-white";
                }


                return (
                  <div
                    key={index}
                    className={`text-center py-2 px-3 cursor-pointer ${bgColor} h-max w-max`}
                    onClick={() => setCurrentQuestion(questionNumber)}
                  >
                    {questionNumber}
                  </div>
                );
              })}
            </div>
          </div>
          <button className="bg-blue-500 min-w-min max-w-max text-white p-[min(2vw,15px)] m-[min(2vw,15px)] rounded-md" onClick={() => {
            Swal.fire({
              title: 'Warning !!',
              text: 'Test going to be submitted.',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Submit',
              cancelButtonText: 'Cancel',
              confirmButtonColor: '#3085d6',
            }).then((result) => {
              if (result.isConfirmed) {
                handleSubmit();
              }
            })
          }
          }>
            Submit
          </button>
        </div>
      </div>
    </div >

  );
};





const QuestionCard = ({ Question, currentQuestion, setResponses, responses }) => {

  const question = Question[currentQuestion - 1];

  return (
    <div className="bg-white shadow rounded p-6 w-[90vw] sm:w-full">

      <div className="text-xl font-bold mb-4">
        <span
          onClick={() => {
            const newResponses = [...responses];
            if (newResponses[currentQuestion - 1].Response.status === 0) {
              newResponses[currentQuestion - 1].Response.status = 2;
            }
            else if (newResponses[currentQuestion - 1].Response.status === 1) {
              newResponses[currentQuestion - 1].Response.status = 3;

            }
            else if (newResponses[currentQuestion - 1].Response.status === 2) {
              newResponses[currentQuestion - 1].Response.status = 0;

            }
            else if (newResponses[currentQuestion - 1].Response.status === 3) {
              newResponses[currentQuestion - 1].Response.status = 1;

            }
            setResponses(newResponses);

          }}
          className="cursor-pointer"
        >
          {(responses[currentQuestion - 1].Response.status === 2 || responses[currentQuestion - 1].Response.status === 3) ? <StarIcon className="text-yellow-600" /> : <StarBorderIcon className="text-yellow-600" />}


        </span>
        <span className="text-2xl font-bold mb-4">{question.QuestionId}. </span>
        {question.Question}
      </div>
      <div className="glassMorphism">
        {question.QuestionType}
      </div>

      {(question.QuestionImg && (question.QuestionImg !== null)) ? (
        <div className="m-2 p-2">
          <img src={`${RESOURCES_API}${question.QuestionImg}`} alt={`Question image url-[${question.QuestionImage}]`} className="w-full sm:w-full md:w-96 lg:w-96" />
        </div>
      ) : null}
      <div className="flex flex-col space-y-4">
        {question.QuestionType === "Single Correct Option" ?
          <SingleOptions question={question} setResponses={setResponses} responses={responses} currentQuestion={currentQuestion} />
          :
          (question.QuestionType === "Multiple Correct Option" ?
            <MultipleOptions question={question} setResponses={setResponses} responses={responses} currentQuestion={currentQuestion} />
            :
            <IntegerType setResponses={setResponses} responses={responses} currentQuestion={currentQuestion} />)}
      </div>
    </div>
  );


};
const MultipleOptions = ({ question, currentQuestion, setResponses, responses }) => {
  const options = [question.Options[0], question.Options[1], question.Options[2], question.Options[3]]

  const handleSelection = (option) => {
    let newResponse = [...responses];
    if (newResponse[currentQuestion - 1].Response.Options.includes(option.OptionId)) {
      newResponse[currentQuestion - 1].Response.Options = newResponse[currentQuestion - 1].Response.Options.filter((opt) => opt !== option.OptionId);
    }
    else {
      newResponse[currentQuestion - 1].Response.Options.push(option.OptionId);
    }

    if (newResponse[currentQuestion - 1].Response.Options.length === 0) {
      if (responses[currentQuestion - 1].Response.status === 2) {
        newResponse[currentQuestion - 1].Response.status = 2;
      }
      else {
        newResponse[currentQuestion - 1].Response.status = 0;
      }
    }
    else {
      if (responses[currentQuestion - 1].Response.status === 2) {
        newResponse[currentQuestion - 1].Response.status = 3;
      }
      else {
        newResponse[currentQuestion - 1].Response.status = 1;
      }
    }
    setResponses(newResponse);
  }

  return (
    <div>
      {options.map((option) => (
        <div key={option.OptionId} className="flex items-center space-x-4">
          <input
            type="checkbox"
            checked={responses[currentQuestion - 1].Response.Options.includes(option.OptionId)}
            onChange={() => {
              handleSelection(option)
            }}
          />
          <button
            onClick={() => {
              handleSelection(option)
            }}
          >
            {option.Option}
          </button>
        </div>
      ))}
    </div>
  )
}

const SingleOptions = ({ question, setResponses, responses, currentQuestion }) => {
  const options = [question.Options[0], question.Options[1], question.Options[2], question.Options[3]]


  const handleOptionSelection = (option) => {
    let newResponses = [...responses];

    if (newResponses[currentQuestion - 1].Response.Options.includes(option.OptionId)) {
      newResponses[currentQuestion - 1].Response.Options = [];
    }
    else {
      newResponses[currentQuestion - 1].Response.Options = [option.OptionId];
    }

    if (newResponses[currentQuestion - 1].Response.Options.length === 0) {
      if (responses[currentQuestion - 1].Response.status === 2) {
        newResponses[currentQuestion - 1].Response.status = 2;
      }
      else {
        newResponses[currentQuestion - 1].Response.status = 0;
      }
    }
    else {
      if (responses[currentQuestion - 1].Response.status === 2) {
        newResponses[currentQuestion - 1].Response.status = 3;
      }
      else {
        newResponses[currentQuestion - 1].Response.status = 1;
      }
    }
    setResponses(newResponses);
  }

  return (
    <div>
      {options.map((option) => (
        <div key={option.OptionId} className="flex items-center space-x-4">
          <input
            type="checkbox"
            checked={responses[currentQuestion - 1].Response.Options.includes(option.OptionId)}
            onChange={() => {
              handleOptionSelection(option)
            }}
          />
          <button
            onClick={() => handleOptionSelection(option)}
          >
            {option.Option}
          </button>
        </div>
      ))}
    </div>
  )
}

const IntegerType = ({ setResponses, responses, currentQuestion }) => {
  const handleValueChange = (e) => {
    let newResponses = [...responses];
    newResponses[currentQuestion - 1].Response.IntegerAnswer = e.target.value;
    if (newResponses[currentQuestion - 1].Response.IntegerAnswer === "") {
      if (responses[currentQuestion - 1].Response.status === 2) {
        newResponses[currentQuestion - 1].Response.status = 2;
      }
      else {
        newResponses[currentQuestion - 1].Response.status = 0;
      }
    }
    else {
      if (responses[currentQuestion - 1].Response.status === 2) {
        newResponses[currentQuestion - 1].Response.status = 3;
      }
      else {
        newResponses[currentQuestion - 1].Response.status = 1;
      }
    }

    setResponses(newResponses);
  };
  return (
    <div key={currentQuestion}>
      <input
        type="number"
        value={responses[currentQuestion - 1].Response.IntegerAnswer}
        key={currentQuestion}
        onChange={(e) => { handleValueChange(e) }}
        placeholder="Enter your answer"
        className="border rounded-md p-2 text-left m-3 border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
      />
    </div>
  );
}



const Timer = ({ timeLimit, setTimeLimit, handleSubmit }) => {
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLimit((prevTimeLimit) => prevTimeLimit - 1);
    }, 1000);

    if (timeLimit <= 0) {
      clearInterval(timer);
      handleSubmit();
    }

    return () => clearInterval(timer);
  }, [timeLimit]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  return (
    <div className="bg-white shadow-2xl text-center rounded-lg p-3">
      <h2 className="text-xl font-bold mb-3">Time Left</h2>
      <div className="sm:text-xl font-bold">{formatTime(timeLimit)}</div>
    </div>
  );
};

const ESCAlert = ({ handleSubmit, handleFullScreen, setESCController }) => {

  const [Timer, setTimer] = useState(8);
  const [open, setOpen] = useState(true)
  const cancelButtonRef = useRef(null)
  const timerRef = useRef(null)

  useEffect(() => {
    timerRef.current = setInterval(() => {
      setTimer((prevTimer) => {
        // console.log(prevTimer);
        if (prevTimer === 1) {
          handleSubmit();
          clearInterval(timerRef.current);
          setOpen(false);
        }
        return prevTimer - 1;
      });
    }, 1000);
    return () => {
      clearInterval(timerRef.current);
    };
  }, []);

  setESCController(open);


  const instructions = {
    Title: "Warning",
    Instructions: "If you are closing the fullscreen window then app will submit test.",
    Warning: "Your test is going to be submitted within 10 seconds"
  }
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                      <FcQuestions className="h-6 w-6 text-gray-500" aria-hidden="true" />
                    </div>
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                      <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                        {instructions.Title}
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          {instructions.Instructions}
                        </p>
                        <p className="text-sm text-red-600">
                          {instructions.Warning}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto"
                    onClick={
                      () => {
                        setOpen(false);
                        clearInterval(timerRef.current);
                        handleFullScreen();
                      }
                    }
                  >
                    Resume Test {Timer}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default Test;
